import {
  ProductOrderReceiptDto,
  CreateProductOrderReceiptDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type ProductOrderReceiptsFilters = PaginatedQueryBase & {
  orderId?: string
}

class ProductOrderReceiptService extends BaseCrudService<
  ProductOrderReceiptDto,
  CreateProductOrderReceiptDto,
  {},
  ProductOrderReceiptsFilters
> {
  constructor() {
    super('product-order-receipt', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const productOrderReceiptService = new ProductOrderReceiptService()
